import type { ReactNode } from 'react'

/**
 * The row-level button size. `.btn` is h-11 — right for a page's primary
 * action, too heavy inside a language row, so rows use this compact variant.
 */
export function MiniButton({
	children,
	onClick,
	tone = 'ghost',
	title,
	disabled,
}: {
	children: ReactNode
	onClick?: () => void
	tone?: 'ghost' | 'accent'
	title?: string
	disabled?: boolean
}) {
	return (
		<button
			type="button"
			onClick={onClick}
			title={title}
			disabled={disabled}
			className={
				'btn h-8 px-3 text-[12px] rounded-nayda-sm shrink-0 ' +
				(tone === 'accent'
					? 'bg-transparent border border-marigold text-ember hover:bg-marigold/25 hover:text-ink'
					: 'btn-ghost')
			}
		>
			{children}
		</button>
	)
}
